module.exports = __webpack_public_path__ + "c52a2539632c4a6365d72d62fd9520fd.pdf";